import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { FadeInWhenVisible } from '../FadeInWhenVisible'
import classes from './impact.module.scss'
import { IImpactProps } from './variables'

const Impact: React.FC<PropsWithChildren<IImpactProps>> = ({ data, title }) => (
  <div className={classes.impact}>
    <div className={classes.container}>
      <FadeInWhenVisible animation={'easySlidingTopFadeIn'} >
        <h3> {title || 'IMPACT'} </h3>
      </FadeInWhenVisible>
      <ul className={classes.impactValues}>
        {data.map((item, idx) => {
          const arrowStyles = [classes.arrow]

          if (item?.icon === 'down') arrowStyles.push(classes.downArrow)
            
          return (
            <div className={classes.impactItem} key={item.id}>
              <FadeInWhenVisible animation={'easySlidingTopFadeIn'} delay={idx * 0.2}>
                <div className={classes.impactValue}>
                  <h3>{item.value}</h3>
                  {item.icon && <svg className={classNames(arrowStyles)} xmlns="http://www.w3.org/2000/svg" width="29.716" height="24.996" viewBox="0 0 29.716 24.996">
                    <path id="Path_6526" data-name="Path 6526" d="M12985.738-2830.015l12.126-19.065,13.438,19.065" transform="translate(-12983.629 2853.571)" fill="none" stroke={item.color.color} strokeWidth="5"/>
                  </svg>}
                </div>
              </FadeInWhenVisible>
              <div className={classes.descriptiveTextContainer}>
                <FadeInWhenVisible animation={'easySlidingTopFadeIn'} delay={idx * 0.3}>
                  <p>{item.name}</p>
                </FadeInWhenVisible>
              </div>
            </div>
          )
        })}
      </ul>
    </div>
  </div>
)
  
export default Impact